import {useLazyQuery, useMutation, useQuery, useSubscription} from "@apollo/client";
import {
    GetCharacter4User,
    GetSubclassesByClass,
    GetValues4CharacterCreation,
    GetValues4LevelUp
} from "../../../GraphQL/CharacterQueries";
import {useAppDispatch, useAppSelector} from "../../../redux/hooks";
import {RootState} from "../../../redux/store";
import React, {useEffect} from "react";
import {
    setCharacter, setCharacterGold,
    setCharacterLevel, setCharacterSilver,
    setCharacterValues,
    setSubclass
} from "../../../redux/slices/character/characterSlice";
import {setIsAppLoading} from "../../../redux/slices/content/contentSlice";
import {CharacterSheet} from "./KampagneTabs/CharacterSheet";
import Button from '../../../Atoms/Button';
import {KampagneInventory} from './KampagneTabs/KampagneInventory';
import {KampagneSpellbook} from './KampagneTabs/KampagneSpellbook';
import {KampagneNotes} from './KampagneTabs/KampagneNotes';

import {
    LevelUpCharacter,
    UpdateAbilities, UpdateCharacter,
    UpdateCharacterSheet,
    UpdateItems,
    UpdateNotes,
    UpdateSkills, UpdateSpells
} from '../../../GraphQL/CharacterMutation';
import {toast} from 'react-toastify';
import {useInterval} from 'usehooks-ts';
import {ActiveContent} from '../../../redux/slices/content/contentType';
import {ArrowForward, SettingsSharp} from "@mui/icons-material";
import {PopUp} from "../../../Atoms/PopUp";
import Input from "../../../Atoms/Input";
import {DropDown} from "../../../Atoms/DropDown";
import {singleCharacterUpdate} from "../../../GraphQL/Subscription";
import {DropdownEntry, emptyCharacter} from "../../../Helper/Constants";
import {GetRaces} from "../../../GraphQL/SystemQueries";
import {character_to_class, Class} from "../../../redux/slices/character/characterType";

export enum currentTab {
    Charakterbogen = "Charakterbogen",
    Inventar = "Inventar",
    Zauberbuch = "Zauberbuch",
    Notizen = "Notizen"
}

interface KampagneMaskProps {
    userId?: number;
    getBack?: () => void;
}

export const KampagneMask = (props: KampagneMaskProps) => {
    const user = useAppSelector((state: RootState) => state.user);
    const adventure = useAppSelector((state: RootState) => state.adventure);
    const character = useAppSelector((state: RootState) => state.character);
    const content = useAppSelector((state: RootState) => state.content);
    const dispatch = useAppDispatch();

    const [ selectedTab, setSelectedTab ] = React.useState<currentTab>(currentTab.Charakterbogen);
    const [ isSettingsPopUpOpen, setIsSettingsPopUpOpen ] = React.useState<boolean>(false);
    const [ isLevelUpPopUpOpen, setIsLevelUpPopUpOpen ] = React.useState<boolean>(false);

    const [ subclasses, setSubclasses ] = React.useState<DropdownEntry[]>([]);
    const [ subClassId, setSubClassId ] = React.useState<number>(0);

    const [ classes, setClasses ] = React.useState<{itemText: string, itemValue: number}[]>([]);

    const [ classId, setClassId ] = React.useState<number>(0);
    const [ hasSubclassRestriction, setHasSubclassRestriction ] = React.useState<boolean>(false);

    const [ isSubclassDropDownDisabled, setIsSubclassDropDownDisabled ] = React.useState<boolean>(true);

    const getCurrentPlayerLevel = () => {
        let playerLevel = 0;
        for (const entry of character.character_to_class) {
            playerLevel = playerLevel + Number(entry.level)
        }

        return playerLevel;
    }


    const {
        data: characterData,
        error: characterError,
        loading: characterLoading
    } = useQuery(GetCharacter4User, {
        variables: {
            userId: Number(user.userId),
            adventureId: Number(adventure.adventureId)
        },
        skip: content.activeContent !== ActiveContent.KampagnePlay,
        fetchPolicy: 'network-only'
    })

    const {} = useSubscription(singleCharacterUpdate, {
        variables: {
            characterId: Number(character.characterId)
        },
        onData({ data: characterSubData }) {
            dispatch(setCharacter({
                characterName: characterSubData.data.singleCharacterUpdate.characterName,
                characterId: Number(characterSubData.data.singleCharacterUpdate.characterId),
                characterLevel: characterSubData.data.singleCharacterUpdate.characterLevel,
                characterExp: characterSubData.data.singleCharacterUpdate.characterExp,
                character_to_class: characterSubData.data.character_to_class,
                Race: characterSubData.data.singleCharacterUpdate.Race,
                Subrace: characterSubData.data.singleCharacterUpdate.Subrace,
                CharacterSheet: characterSubData.data.singleCharacterUpdate.CharacterSheet
            }))
        }
    })

    const [ loadClasses, {
        data: classesData,
        error: classesError,
        loading: classesLoading
    }] = useLazyQuery(GetValues4LevelUp, {
        fetchPolicy: 'network-only'
    })

    const [ updateCharacterSheetHook ] = useMutation(UpdateCharacterSheet);
    const [ updateSkillHook ] = useMutation(UpdateSkills);
    const [ updateAbilitiesHook ] = useMutation(UpdateAbilities);
    const [ updateNotesHook ] = useMutation(UpdateNotes);
    const [ updateItemsHook ] = useMutation(UpdateItems);
    const [ updateSpellsHook ] = useMutation(UpdateSpells);
    const [ updateCharacterHook ] = useMutation(UpdateCharacter);
    const [ levelUpHook ] = useMutation(LevelUpCharacter)

    useInterval(async () => {
        if (content.activeContent === ActiveContent.KampagnePlay) {
            await handleSaveCharacter();
        }
    }, 600000);

    useEffect(() => {
        if (characterData && !characterLoading) {
            if (characterData.getCharacters4User) {
                dispatch(setCharacter({
                    characterName: characterData.getCharacters4User.characterName,
                    characterId: Number(characterData.getCharacters4User.characterId),
                    characterLevel: characterData.getCharacters4User.characterLevel,
                    characterExp: characterData.getCharacters4User.characterExp,
                    character_to_class: characterData.getCharacters4User.character_to_class,
                    Race: characterData.getCharacters4User.Race,
                    Subrace: characterData.getCharacters4User.Subrace,
                    CharacterSheet: characterData.getCharacters4User.CharacterSheet
                }))
            } else {
                dispatch(setCharacter(emptyCharacter))
            }
        }
    }, [ characterData ])

    useEffect(() => {
        if (characterLoading) {
            dispatch(setIsAppLoading({
                isAppLoading: true,
                loadingText: 'Lade den Charakter, könnte einen Moment dauern'
            }))
        } else {
            dispatch(setIsAppLoading({isAppLoading: false, loadingText: ''}))
        }
    }, [ characterLoading ])

    const checkForSelectedTab = (tab: string) => {
        if (tab === selectedTab) {
            return 'tab-button-selected'
        } else {
            return 'tab-button'
        }
    }

    const renderContent = () => {
        switch (selectedTab) {
            case currentTab.Charakterbogen:
                return <CharacterSheet/>
            case currentTab.Inventar:
                return <KampagneInventory/>
            case currentTab.Notizen:
                return <KampagneNotes/>
            case currentTab.Zauberbuch:
                return <KampagneSpellbook/>
        }
    }

    const checkIfLevelUpIsActive = () => {
        if (character.characterExp > 0) {
            const rest = character.characterExp / getCurrentPlayerLevel();
            return rest < 1500;
        } else {
            return true
        }
    }

    const handleSaveCharacter = async () => {
        dispatch(setIsAppLoading({
            loadingText: 'Der Charakter wird gespeichert, das kann einen Moment dauern...',
            isAppLoading: true
        }))

        const abilityList = [];
        for (const entry of character.CharacterSheet.ability_to_characterSheet) {
            abilityList.push({
                ability_to_characterSheetId: Number(entry.ability_to_characterSheetId),
                value: Number(entry.value),
                proficiencyAmount: Number(entry.proficiencyAmount)
            })
        }

        await updateAbilitiesHook({
            variables: {
                atc: abilityList
            }
        })

        const skillList = [];
        for (const skillEntry of character.CharacterSheet.skill_to_characterSheet) {
            skillList.push({
                skill_to_characterSheetId: Number(skillEntry.skill_to_characterSheetId),
                value: Number(skillEntry.value),
                proficiencyAmount: Number(skillEntry.proficiencyAmount)
            })
        }

        await updateSkillHook({
            variables: {
                stc: skillList
            }
        })

        const noteList = [];
        for (const note of character.CharacterSheet.Note) {
            noteList.push({
                noteId: Number(note.noteId),
                noteText: note.noteText,
                noteHeader: note.noteHeading
            })
        }

        await updateNotesHook({
            variables: {
                noteList: noteList,
                characterSheetId: Number(character.CharacterSheet.characterSheetId)
            }
        })

        const itemList = [];
        for (const item of character.CharacterSheet.Item) {
            itemList.push({
                itemId: Number(item.itemId),
                itemAmount: Number(item.itemAmount),
                itemDescription: item.itemDescription
            })
        }

        await updateItemsHook({
            variables: {
                itemList: itemList,
                characterSheetId: Number(character.CharacterSheet.characterSheetId)
            }
        })

        const spellList = [];
        const avaibleAbilityId = Number(character.CharacterSheet.ability_to_characterSheet[0].Ability.abilityId)
        for (const spell of character.CharacterSheet.Spell) {
            spellList.push({
                spellId: Number(spell.spellId),
                spellText: spell.spellText,
                spellTarget: spell.spellTarget,
                spellName: spell.spellName,
                spellDuration: spell.spellDuration,
                spellCost: Number(spell.spellCost),
                spellComponents: spell.spellComponents,
                savingThrow: Number(spell.savingThrow.abilityId) > 0 ? Number(spell.savingThrow.abilityId) : avaibleAbilityId,
                isConcentration: spell.isConcentration,
                isActive: spell.isActive,
                spellListTypeId: spell.spellListType !== null ? Number(spell.spellListType.spellListTypeId) : 0,
                spellType: Number(spell.spellType)
            })
        }

        console.log(spellList);

        await updateSpellsHook({
            variables: {
                spellList: spellList,
                characterSheetId: Number(character.CharacterSheet.characterSheetId)
            },
            refetchQueries: [
                {
                    query: GetCharacter4User,
                    variables: {
                        userId: Number(user.userId),
                        adventureId: Number(adventure.adventureId)
                    },
                    fetchPolicy: 'network-only'
                } ]
        })

        await updateCharacterSheetHook({
            variables: {
                characterSheetId: Number(character.CharacterSheet.characterSheetId),
                characterId: Number(character.characterId),
                initiative: Number(character.CharacterSheet.initiative),
                armorClass: Number(character.CharacterSheet.armorClass),
                lifepoints: Number(character.CharacterSheet.lifepoints),
                currentHitpoints: Number(character.CharacterSheet.currentHitpoints),
                temporaryHitpoints: Number(character.CharacterSheet.temporaryHitpoints),
                currentMana: Number(character.CharacterSheet.currentMana),
                languages: character.CharacterSheet.languages,
                spellAttackModifier: character.CharacterSheet.spellAttackModifier,
                spellSaveDc: character.CharacterSheet.spellSaveDc,
                gold: character.CharacterSheet.gold,
                silver: character.CharacterSheet.silver
            }
        })

        await updateCharacterHook({
            variables: {
                characterId: Number(character.characterId),
                characterName: character.characterName,
                characterLevel: Number(character.characterLevel),
                characterExp: Number(character.characterExp),
                raceId: Number(character.Race.raceId),
                subraceId: character.Subrace !== null? Number(character.Subrace.subraceId):0,
                userId: content.activeContent === 'Adventure Mask' ? Number(props.userId) : Number(user.userId),
                adventureId: Number(adventure.adventureId)
            }
        })

        toast('Charakter erfolgreich gespeichert');

        dispatch(setIsAppLoading({loadingText: '', isAppLoading: false}))
    }
    
    const getRaceText = () => {
        return character.Subrace !== null ? character.Subrace.subraceName : character.Race.raceName
    }
    
    const setCurrency = (value: number, type: "Gold" | "Silver") => {
        if (type === "Gold") {
            dispatch(setCharacterGold(value))
        } else {
            dispatch(setCharacterSilver(value))
        }
    }

    const getBack = () => {
        if (props.getBack !== undefined) {
            props.getBack()
        }
    }

    const findUsedClass = () => {
        return character.character_to_class.find((entry: character_to_class) => {
            return Number(entry.Class.classId) === Number(classId)
        })
    }

    const handleSetClass = (classId: number) => {
        if (classId > 0) {
            const index = classesData.getClasses.findIndex((entry: Class) => Number(entry.classId) === classId)
            const foundClass = character.character_to_class.find((entry: character_to_class) => {
                return Number(entry.Class.classId) === Number(classId)
            })

            // Baue Dropdown für die Subklasse
            const subclassList = [];
            subclassList.push({
                itemText: 'Noch keine Subklasse ausgewählt',
                itemValue: 0
            })

            for (const subclass of classesData.getClasses[index].Subclass) {
                subclassList.push({
                    itemText: subclass.subclassName,
                    itemValue: Number(subclass.subclassId)
                })
            }

            setSubclasses(subclassList)

            // Hat Klasse schon
            if (foundClass !== undefined) {

                // Hat bereits eine Subklasse
                if (foundClass.Subclass !== null) {
                    // Setze Subklasse ins Dropdown
                    setSubClassId(foundClass.Subclass.subclassId);

                    // Deaktiviere Dropdown
                    setIsSubclassDropDownDisabled(true);
                }
                // Hat keine Subklasse
                else {
                    // Setze Subklasse auf nichts
                    setSubClassId(0);

                    // Kann eine Subklasse festlegen
                    if (Number(foundClass.level) >= Number(classesData.getClasses[index].subclassLevel - 1)) {
                        // Aktiviere Subklassen Dropdown
                        setIsSubclassDropDownDisabled(false)
                    } else {
                        // Besitzt nicht das nötige Level -> deaktiviere Subklassen Dropdown
                        setIsSubclassDropDownDisabled(true)
                    }
                }
            } else {
                // Hat Klasse noch nicht
                // Setze Subklasse auf nichts
                setSubClassId(0);

                // Kann eine Subklasse festlegen
                if (1 >= Number(classesData.getClasses[index].subclassLevel)) {
                    // Aktiviere Subklassen Dropdown
                    setIsSubclassDropDownDisabled(false)
                } else {
                    // Besitzt nicht das nötige Level -> deaktiviere Subklassen Dropdown
                    setIsSubclassDropDownDisabled(true)
                }
            }

        }

        setClassId(classId);

    }

    const handleLevelUp = async () => {
        let saveSubclass = subClassId === 0 ? false : !hasSubclassRestriction;

        await levelUpHook({
            variables: {
                characterId: Number(character.characterId),
                classId: classId === 0 ? null : Number(classId),
                subclassId: saveSubclass ? Number(subClassId) : null
            },
            refetchQueries: [
                {
                    query: GetCharacter4User,
                    variables: {
                        userId: Number(user.userId),
                        adventureId: Number(adventure.adventureId)
                    },
                    fetchPolicy: 'network-only'
                } ]
        })

        await handleSaveCharacter();
        setIsLevelUpPopUpOpen(false);
    }

    const renderLevelUpPreview = () => {
        if (classId > 0) {
            const foundClass = findUsedClass()
            if (foundClass !== undefined) {
                return (
                    <div>
                        { foundClass.Class.className } { foundClass.level } <ArrowForward/> { foundClass.level + 1 }
                    </div>
                )
            } else {
                const classData = classes.find((entry) => entry.itemValue === Number(classId));
                if (classData) {
                    return (
                        <div>
                            { classData.itemText } 0 <ArrowForward/> 1
                        </div>
                    )
                }
            }
        }
    }

    return (
        <>
            {!characterLoading && (
                <div className=''>
                    { isSettingsPopUpOpen && (
                        <>
                            <PopUp onClose={() => setIsSettingsPopUpOpen(false)} title={"Anpassungen"}>
                                <div className='setting_container'>
                                    <div className='name-input'>
                                        <Input label="Name" value={character.characterName} type="text"
                                               onChange={(event) => dispatch(setCharacterValues({
                                                   characterName: event.target.value,
                                                   characterId: character.characterId
                                               }))}/>
                                    </div>
                                    <div className="header">Aktuelle Klassen</div>
                                    { character.character_to_class.map((entry) => {
                                        return (
                                            <div className="chosen_combination" key={entry.characterToClassId}>
                                                <div className="chosen_class">
                                                    Klasse: { entry.Class.className }
                                                </div>
                                                <div className="current_level">
                                                    Level: { entry.level }
                                                </div>
                                                <div className="chosen_subclass">
                                                    { entry.Subclass !== null ? entry.Subclass.subclassName : null }
                                                </div>
                                            </div>
                                        )
                                    }) }
                                </div>
                            </PopUp>
                        </>
                    )}
                    { isLevelUpPopUpOpen && (
                        <>
                            <PopUp onClose={() => setIsLevelUpPopUpOpen(false)} title="Level-Up">
                                <div className="level-up-popup">
                                    <div className="header">Aktuelle Klassen</div>
                                    <div className="current_classes">
                                        { character.character_to_class.map((entry) => {
                                            return (
                                                <div className="chosen_combination" key={entry.characterToClassId}>
                                                    <div className="chosen_class">
                                                        Klasse: { entry.Class.className }
                                                    </div>
                                                    <div className="current_level">
                                                        Level: { entry.level }
                                                    </div>
                                                    <div className="chosen_subclass">
                                                        { entry.Subclass !== null ? entry.Subclass.subclassName : null }
                                                    </div>
                                                </div>
                                            )
                                        }) }
                                    </div>
                                    <div className="header">Aktuelle Auswahl</div>
                                    <div className="add-new-level-container">
                                        <div className="class_dropdown">
                                            <DropDown value={classId} setValue={event => handleSetClass(Number(event.target.value))} items={classes}/>
                                        </div>
                                        <div className="level-up-preview">
                                            { renderLevelUpPreview() }
                                        </div>
                                        { classId > 0 && (
                                            <div className="subclass_dropdown">
                                                <DropDown label='Subklasse:' value={subClassId}
                                                          setValue={(event) => setSubClassId(Number(event.target.value))} items={subclasses}
                                                          disabled={ isSubclassDropDownDisabled }/>
                                            </div>
                                        ) }
                                    </div>
                                    <div className="confirm-button">
                                        <Button disabled={ (Number(classId) === 0) || (!isSubclassDropDownDisabled && subClassId === 0) } onClick={async() => await handleLevelUp()}>Bestätigen</Button>
                                    </div>
                                </div>
                            </PopUp>
                        </>
                    )

                    }
                    {character.characterId > 0 && (
                        <div className='adventure_header'>
                            <div className='info_header'>
                                <div className='info_header_textbox'>
                                    <>
                                        <h3>{adventure.adventureName} <SettingsSharp
                                            className='info_header_settings_icon'
                                            onClick={() => setIsSettingsPopUpOpen(true)}
                                            titleAccess='Anpassen'
                                        /></h3>
                                        <p><b>{character.characterName}</b> { getRaceText() }</p>
                                        <p className='info_header_textbox_level'>
                                            Level: { getCurrentPlayerLevel() }
                                            <label style={{marginLeft: '1rem'}}>Erfahrung: </label>
                                            <input className='exp_input' value={character.characterExp}
                                                   onChange={(event) => dispatch(setCharacterLevel({
                                                       characterExp: Number(event.target.value),
                                                       characterLevel: character.characterLevel
                                                   }))}/>
                                        </p>
                                    </>
                                </div>
                                <div className='info_header_currency'>
                                    <div>
                                        <label>Silber</label>
                                        <input value={character.CharacterSheet.silver} type="number" onChange={(e) => setCurrency(Number(e.target.value), "Silver")}/>
                                    </div>
                                    <div>
                                        <label>Gold</label>
                                        <input value={character.CharacterSheet.gold} type="number" onChange={(e) => setCurrency(Number(e.target.value), "Gold")}/>
                                    </div>
                                </div>
                                <div className='character_header_button_area'>
                                    { content.activeContent !== ActiveContent.KampagnePlay && (
                                        <Button onClick={ () => getBack() }>Zurück</Button>
                                    ) }
                                    <Button onClick={async () => {
                                        const result = await loadClasses();
                                        if (result.data) {
                                            const classDropDownList = [];

                                            classDropDownList.push({
                                                itemText: 'Noch keine Klasse ausgewählt',
                                                itemValue: 0
                                            });
                                            for (const entry of result.data.getClasses) {
                                                classDropDownList.push({
                                                    itemText: entry.className,
                                                    itemValue: Number(entry.classId),
                                                })
                                            }

                                            setClasses(classDropDownList)
                                        }
                                        setIsLevelUpPopUpOpen(true);
                                    }}
                                            disabled={checkIfLevelUpIsActive()}>Level-Up</Button>
                                    <Button onClick={async () => await handleSaveCharacter()}>Speichern</Button>
                                </div>
                            </div>
                            <div>
 
                            </div>
                            <div className='character_navigation'>
                                <div className=''>
                                    <Button className={checkForSelectedTab(currentTab.Charakterbogen)}
                                            onClick={() => setSelectedTab(currentTab.Charakterbogen)}>Charakter</Button>
                                </div>
                                <div className=''>
                                    <Button className={checkForSelectedTab(currentTab.Inventar)}
                                            onClick={() => setSelectedTab(currentTab.Inventar)}>Inventar</Button>
                                </div>
                                <div className=''>
                                    <Button className={checkForSelectedTab(currentTab.Zauberbuch)}
                                            onClick={() => setSelectedTab(currentTab.Zauberbuch)}>Zauberbuch</Button>
                                </div>
                                <div className=''>
                                    <Button className={checkForSelectedTab(currentTab.Notizen)}
                                            onClick={() => setSelectedTab(currentTab.Notizen)}>Notizen</Button>
                                </div>
                            </div>
                        </div>
                    )}
                    <div
                        className={content.activeContent === ActiveContent.KampagnePlay ? 'kampagne-container mt-2' : 'characterSheet-container mt-3'}>
                        <>
                            {renderContent()}
                        </>
                    </div>
                </div>
            )}
        </>
    )
}